import * as yup from "yup";
import { VALIDATION_ERROR } from "../enums";

export const createClientSchema = yup.object().shape({
    name: yup.string().min(2, VALIDATION_ERROR.MIN_LENGTH).required(VALIDATION_ERROR.REQUIRED),
    codeName: yup.string().min(2, VALIDATION_ERROR.MIN_LENGTH).required(VALIDATION_ERROR.REQUIRED),
    siteURL: yup.string().url()
});
